import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { ContentLayoutComponent } from './';
import { HeaderComponent } from './header/header.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { ContentHeaderComponent } from './content-header/content-header.component';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    ContentLayoutComponent,
    HeaderComponent,
    BreadcrumbsComponent,
    UnauthorizedComponent,
    NotfoundComponent,
    ContentHeaderComponent,
    FooterComponent
  ],
  exports: [

  ]
})
export class LayoutModule {}


